import { everyChecker } from './checkers/everyChecker'

// stake always shoud be in array
export const objToStringSettings = (obj: any, defArr: any) => {
  const { minStake, maxStake } = defArr

  let str = ''

  defArr.map((item: any) => {
    if (item.name === 'stake') {
      obj[item.name].map(
        (it: any) =>
          (str += everyChecker[item.name](it, minStake, maxStake) + ';'),
      )
    } else {
      str += everyChecker[item.name](obj[item.name]) + ';'
    }
  })

  return str
}
